import {
  PaidService,
  PaymentMethodEnum,
  PaymentResult
} from '@/__generated_graphql__/graphql';
import { PaymentTypeEnum, PaymentWayKey } from '@/constants/common';
import { THEME_MODE } from '@/hooks/useThemeMode';
import { CardAd } from '@/types';

export type PlanCardStyle = { color: string };
export type PlanTheme = typeof THEME_MODE;

export const PLAN_VARIANT = { active: 'active', inactive: 'inactive' } as const;
export const PLAN_VARIANT_THEME_KEYS = {
  ACTIVE_LIGHT: 'active_light',
  INACTIVE_LIGHT: 'inactive_light',
  ACTIVE_DARK: 'active_dark',
  INACTIVE_DARK: 'inactive_dark'
} as const;

export type PlanVariant = keyof typeof PLAN_VARIANT;
export type PlanVariantThemeKey =
  (typeof PLAN_VARIANT_THEME_KEYS)[keyof typeof PLAN_VARIANT_THEME_KEYS];

export const CARD_IDS = { TOP: 'TOP', PREMIUM: 'PREMIUM' } as const;
export type CardId = keyof typeof CARD_IDS;

export const ServiceType = { TOP: 'TOP', PREMIUM: 'PREMIUM' } as const;
export type ServiceTypeKey = keyof typeof ServiceType;

export const ServiceTypeMap = {
  [ServiceType.TOP]: 'bump',
  [ServiceType.PREMIUM]: 'featured'
} as const;

export type MappedServiceType =
  (typeof ServiceTypeMap)[keyof typeof ServiceTypeMap];

export type ServicePeriodItem = {
  id: number;
  count: string;
  periodTime: string;
  price: string;
};
export type ServicePeriodItems = ServicePeriodItem[];

export type ExtendedPaymentMethodEnum = PaymentMethodEnum | 'personal';

export type PaymentOption = {
  key: PaymentWayKey;
  label: string;
  extra?: React.ReactNode;
};

export type PaidOption = { id: string; name: string; price: number };

export type ViewMethod = {
  id: PaymentMethodEnum;
  name: string;
  balance?: number | null;
};

export type PaidServiceExtra = { id: string; options: PaidOption[] };

export const SKELETON_COUNT_BY_TYPE: Record<string, number> = {
  Vacancy: 4,
  Resume: 3
};

export type ActivePaidService =
  | string
  | { serviceId: string; price: number }
  | null;

export type ExtraContentModalProps = {
  ad: CardAd;
  activePeriodId: number | null;
  activeCard: string;
  activePaidServiceId: ActivePaidService;
  isExtraContentVisible: boolean;
  isAddBalance: boolean;
  isLoading: boolean;
  type: PaymentTypeEnum;
  contentTitle: string;
  paidServices: PaidService[];
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  onConfirmPayment: (
    method: PaymentMethodEnum,
    paidServiceId: ActivePaidService,
    isAddBalance?: boolean
  ) => Promise<PaymentResult | null>;
  onBack: () => void;
  onClose: () => void;
  setActivePaidServiceId: React.Dispatch<
    React.SetStateAction<ActivePaidService>
  >;
  setActivePeriodId: React.Dispatch<React.SetStateAction<number | null>>;
};
